import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ChecksBanner, { ChecksBannerItem } from './ChecksBanner.tsx';
import { FormField } from './useDocumentConfig.ts';
import { collectValidationChecks, isDisplayedIncompleteCheck, summarizeValidationChecks } from './validationChecks.ts';

interface IncompleteChecksBannerProps {
    document: any;
    itemFormFieldGroups: Record<string, FormField[][]>;
}

const IncompleteChecksBanner = ({ document, itemFormFieldGroups }: IncompleteChecksBannerProps) => {
    const { t } = useTranslation('assistance');

    const summaries = useMemo(
        () =>
            summarizeValidationChecks(
                t,
                collectValidationChecks(document, Object.keys(itemFormFieldGroups)),
                isDisplayedIncompleteCheck
            ),
        [document, itemFormFieldGroups, t]
    );

    if (summaries.length === 0) return null;

    return (
        <ChecksBanner severity="info" title={t('validationChecks.aiRulesNotRun')} itemCount={summaries.length}>
            {summaries.map(({ message }) => (
                <ChecksBannerItem key={message} message={message} />
            ))}
        </ChecksBanner>
    );
};

export default IncompleteChecksBanner;
